export default {"src":"/_next/static/media/PolicyGenius.4f8181ba.svg","height":186,"width":1038,"blurWidth":0,"blurHeight":0};